import type {
  BBAnnotationStyles,
  BoundingBoxCoordinate,
  Offest,
  XYCoordinate,
} from '../types';

export const drawBox = (input: {
  coordintate: BoundingBoxCoordinate;
  styles: BBAnnotationStyles;
  context: CanvasRenderingContext2D;
  offset?: Offest;
  scale?: number;
}) => {
  const {
    coordintate,
    styles,
    context,
    offset = { dx: 0, dy: 0 },
    scale = 1,
  } = input;
  context.beginPath();
  context.strokeStyle = styles.strokeColor;
  context.lineWidth = styles.strokeWidth;
  if (styles.strokeDashArray) {
    context.setLineDash(styles.strokeDashArray);
  }
  context.rect(
    (coordintate.x + offset.dx) * scale,
    (coordintate.y + offset.dy) * scale,
    coordintate.width * scale,
    coordintate.height * scale,
  );
  context.stroke();
};

export const getBoxCoordatesForUserDraw = (
  startCoordinates: XYCoordinate,
  endCoordinates: XYCoordinate,
) => {
  const x = startCoordinates.x;
  const y = startCoordinates.y;
  const width = endCoordinates.x - x;
  const height = endCoordinates.y - y;

  return { x, y, width, height };
};

export const getBoxCoordatesForUserUpdate = (
  startCoordinates: XYCoordinate,
  size: { width: number; height: number },
) => {
  const x = startCoordinates.x;
  const y = startCoordinates.y;
  const width = size.width;
  const height = size.height;

  return { x, y, width, height };
};
